<template>
  <section class="listing">
    <div class="actions">
      <button @click="$router.push('/bordero')" class="button-previous"><i
          class="fas fa-angle-left"></i><span>Voltar</span></button>
      <div class="print-type">
        <div @click="full = false" :class="{ 'print-type-selected': !full }">Simples</div>
        <div @click="full = true" :class="{ 'print-type-selected': full }">Completo</div>
      </div>
      <button @click="print" class="button-save"><i class="fas fa-print"></i><span>Imprimir</span></button>
    </div>
    <div class="print-header" style="d">
      <div class="print-title">Borderô</div>
      <div style="font-size: 0.9em; color: #555;">{{ (new Date()).toLocaleString('pt-br') }}</div>
      <!-- <img logo /> -->
    </div>
    <div v-if="business" class="print-business">
      <div>
        <div class="print-text" style="font-size: 1.5em">{{ business.nameReal }}</div>
        <div class="print-text">{{ business.regDocument }}</div>
        <div class="print-text">{{ business.addressStreet }}, {{ business.addressNumber }}</div>
        <div class="print-text">{{ business.addressCity }} - {{ business.addressState }} - {{ business.addressPostcode
        }}</div>
      </div>
      <div>
        <div class="print-text" style="font-size: 1.5em">{{ producer.name }}</div>
      </div>
      <div>
        <div class="print-text" style="font-size: 1.1em; font-weight: 300">CAPACIDADE</div>
        <div class="print-text" style="font-size: 2em">{{ business.capacity.toLocaleString('pt-br', {
            minimumFractionDigits: 0
          })
        }}</div>
      </div>
    </div>
    <transition name="show" mode="out-in">
      <i v-if="!show" class="fas fa-spinner loading-big"></i>
      <div v-if="show">
        <div class="list">
          <div class="calendar">
            <span>{{ getDay(show.showDate[0].date) }}</span>
            <span>{{ getMonthText(show.showDate[0].date) }}</span>
          </div>
          <div class="time-text">
            <span>{{ getHours(show.showDate[0].date) }}</span>
            <span>{{ getMinutes(show.showDate[0].date) }}</span>
          </div>
          <div class="data">
            <div class="main-data">{{ show.show.name }}</div>
            <div class="detail-data">{{ `${show.show.duration}min | ${show.show.type}` }}</div>
          </div>
        </div>
        <div class="information" style="margin: 30px 5px 5px">
          <!-- Resultado -->
          <div class="info-box info-bigger">
            <div class="info-text">Resultado</div>
            <div class="info-value">{{ (revenue - expense).toLocaleString('pt-br', {
                style: 'currency', currency: 'BRL'
              })
            }}</div>
          </div>
          <!-- Receitas -->
          <div class="info-box">
            <div class="info-text">Receitas</div>
            <div class="info-value info-reveneu">{{ revenue.toLocaleString('pt-br', {
                style: 'currency', currency: 'BRL'
              })
            }}</div>
          </div>
          <!-- Despesas -->
          <div class="info-box">
            <div class="info-text">Despesas</div>
            <div class="info-value info-expense">{{ expense.toLocaleString('pt-br', {
                style: 'currency', currency: 'BRL'
              })
            }}</div>
          </div>
        </div>
        <div class="information" style="margin: 0 5px 20px">
          <!-- Não Vendidos -->
          <div v-if="!show.show.online" class="info-box">
            <div class="info-text">Não Vendidos</div>
            <div class="info-value">
              {{ notSold.toLocaleString('pt-br', { minimumFractionDigits: 0 }) }}
              <span>({{ (notSold / capacity * 100).toLocaleString('pt-br', { maximumFractionDigits: 1 }) }}%)</span>
            </div>
          </div>
          <!-- Não Pagante -->
          <div v-if="!show.show.online" class="info-box">
            <div class="info-text">Não Pagante</div>
            <div class="info-value">
              {{ free.toLocaleString('pt-br', { minimumFractionDigits: 0 }) }}
              <span>({{ (free / capacity * 100).toLocaleString('pt-br', { maximumFractionDigits: 1 }) }}%)</span>
            </div>
          </div>
          <!-- Pagante -->
          <div class="info-box">
            <div class="info-text">Pagante</div>
            <div class="info-value">
              {{ paid.toLocaleString('pt-br', { minimumFractionDigits: 0 }) }}
              <span v-if="!show.show.online">({{ (paid / capacity * 100).toLocaleString('pt-br', {
                  maximumFractionDigits: 1
                })
              }}%)</span>
            </div>
          </div>
          <!-- Total -->
          <div class="info-box">
            <div class="info-text">Total</div>
            <div class="info-value">
              {{ total.toLocaleString('pt-br', { minimumFractionDigits: 0 }) }}
              <span v-if="!show.show.online">({{ occupation.toLocaleString('pt-br', { maximumFractionDigits: 1 })
              }}%)</span>
            </div>
          </div>
        </div>

        <table class="table-bordero">
          <br>
          <br>
          <tr>
            <th colspan="6">ENTRADAS</th>
          </tr>
          <tr>
            <th>Canal</th>
            <th>Tipo de ingresso</th>
            <th>Valor</th>
            <th>Qtd</th>
            <th>Subtotal</th>
            <th>Totais</th>
          </tr>
          <tr v-for="(ticket, index) in ticketsBusiness" :key="ticket.name">
            <td v-if="index === 0" :rowspan="ticketsBusiness.length"><b>Bilheteria</b></td>
            <td align="left">{{ ticket.ticketType }}</td>
            <td style="min-width:100px;" align="right">R$ {{ ticket.price.toLocaleString('pt-br', {
                minimumFractionDigits: 2
              })
            }}</td>
            <td style="min-width:70px;" align="right">{{ ticket.count }}</td>
            <td style="min-width:100px;" align="right">R$ {{ ticket.sum.toLocaleString('pt-br', {
                minimumFractionDigits:
                  2
              })
            }}</td>
            <td style="min-width:100px;" v-if="index === 0" :rowspan="ticketsBusiness.length" align="right">R$ {{
                ticketsBusiness.map(x => x.sum).reduce((acc, cur) => acc + Number(cur), 0).toLocaleString('pt-br', {
                  minimumFractionDigits: 2
                })
            }}</td>
          </tr>
          <tr v-for="(ticket, index) in ticketsTiketera" :key="ticket.name">
            <td v-if="index === 0" :rowspan="ticketsTiketera.length"><b>Online</b></td>
            <td align="left">{{ ticket.ticketType }}</td>
            <td style="min-width:100px;" align="right">R$ {{ ticket.price.toLocaleString('pt-br', {
                minimumFractionDigits: 2
              })
            }}</td>
            <td style="min-width:70px;" align="right">{{ ticket.count }}</td>
            <td style="min-width:100px;" align="right">R$ {{ ticket.sum.toLocaleString('pt-br', {
                minimumFractionDigits:
                  2
              })
            }}</td>
            <td style="min-width:100px;" v-if="index === 0" :rowspan="ticketsTiketera.length" align="right">R$ {{
                ticketsTiketera.map(x => x.sum).reduce((acc, cur) => acc + Number(cur), 0).toLocaleString('pt-br', {
                  minimumFractionDigits: 2
                })
            }}</td>
          </tr>
          <tr>
            <td colspan="5"></td>
            <td align="right"><b>R$ {{ (ticketsBusiness.map(x => x.sum).reduce((acc, cur) => acc + Number(cur), 0) +
                ticketsTiketera.map(x => x.sum).reduce((acc, cur) => acc + Number(cur), 0)).toLocaleString('pt-br', {
                  minimumFractionDigits: 2
                })
            }}</b></td>
          </tr>
        </table>

        <table class="table-bordero">
          <br>
          <br>
          <tr>
            <th colspan="8">SAÍDAS</th>
          </tr>
          <tr>
            <th>Despesas</th>
            <th colspan="2">Canal</th>
            <th>Valor</th>
            <th>Taxa</th>
            <th>Qtd</th>
            <th>Subtotal</th>
            <th>Totais</th>
          </tr>
          <tr>
            <td rowspan="7">Taxas de pagamento</td>
            <td rowspan="4"><b>Bilheteria</b></td>
            <td>Crédito</td>
            <td align="right">{{ toMoney(fees.payment.ticket.credit.value) }}</td>
            <td align="right">{{ fees.payment.ticket.credit.fee }} %</td>
            <td align="right">{{ fees.payment.ticket.credit.amount }}</td>
            <td align="right">{{ toMoney(fees.payment.ticket.credit.subtotal) }}</td>
            <td rowspan="4" align="right">{{ toMoney(fees.payment.ticket.credit.subtotal +
                fees.payment.ticket.debit.subtotal + fees.payment.ticket.pix.subtotal + fees.payment.ticket.cash.subtotal)
            }}</td>
          </tr>
          <tr>
            <td>Débito</td>
            <td align="right">{{ toMoney(fees.payment.ticket.debit.value) }}</td>
            <td align="right">{{ fees.payment.ticket.debit.fee }} %</td>
            <td align="right">{{ fees.payment.ticket.debit.amount }}</td>
            <td align="right">{{ toMoney(fees.payment.ticket.debit.subtotal) }}</td>
          </tr>
          <tr>
            <td>PIX</td>
            <td align="right">{{ toMoney(fees.payment.ticket.pix.value) }}</td>
            <td align="right">{{ fees.payment.ticket.pix.fee }} %</td>
            <td align="right">{{ fees.payment.ticket.pix.amount }}</td>
            <td align="right">{{ toMoney(fees.payment.ticket.pix.subtotal) }}</td>
          </tr>
          <tr>
            <td>Dinheiro</td>
            <td align="right">{{ toMoney(fees.payment.ticket.cash.value) }}</td>
            <td align="right">{{ fees.payment.ticket.cash.fee }} %</td>
            <td align="right">{{ fees.payment.ticket.cash.amount }}</td>
            <td align="right">{{ toMoney(fees.payment.ticket.cash.subtotal) }}</td>
          </tr>
          <tr>
            <td rowspan="3"><b>Online</b></td>
            <td>Crédito</td>
            <td align="right">{{ toMoney(fees.payment.online.credit.value) }}</td>
            <td align="right">{{ fees.payment.online.credit.fee }} %</td>
            <td align="right">{{ fees.payment.online.credit.amount }}</td>
            <td align="right">{{ toMoney(fees.payment.online.credit.subtotal) }}</td>
            <td rowspan="3" align="right">{{ toMoney(fees.payment.online.credit.subtotal +
                fees.payment.online.pix.subtotal + fees.payment.online.billet.subtotal)
            }}</td>
          </tr>
          <tr>
            <td>PIX</td>
            <td align="right">{{ toMoney(fees.payment.online.pix.value) }}</td>
            <td align="right">{{ fees.payment.online.pix.fee }} %</td>
            <td align="right">{{ fees.payment.online.pix.amount }}</td>
            <td align="right">{{ toMoney(fees.payment.online.pix.subtotal) }}</td>
          </tr>
          <tr>
            <td>Boleto</td>
            <td align="right">{{ toMoney(fees.payment.online.billet.value) }}</td>
            <td align="right">{{ toMoney(fees.payment.online.billet.fee) }}</td>
            <td align="right">{{ fees.payment.online.billet.amount }}</td>
            <td align="right">{{ toMoney(fees.payment.online.billet.subtotal) }}</td>
          </tr>
          <tr>
            <td>Taxa de impressão</td>
            <td colspan="2"><b>Bilheteria</b></td>
            <td align="right">{{ toMoney(fees.print.value) }}</td>
            <td align="right">{{ toMoney(fees.print.fee) }}</td>
            <td align="right">{{ fees.print.amount }}</td>
            <td align="right">{{ toMoney(fees.print.subtotal) }}</td>
            <td align="right">{{ toMoney(fees.print.subtotal) }}</td>
          </tr>
          <tr>
            <td>Taxa de emissão</td>
            <td colspan="2"><b>Online</b></td>
            <td align="right">{{ toMoney(fees.issue.value) }}</td>
            <td align="right">{{ toMoney(fees.issue.fee) }}</td>
            <td align="right">{{ fees.issue.amount }}</td>
            <td align="right">{{ toMoney(fees.issue.subtotal) }}</td>
            <td align="right">{{ toMoney(fees.issue.subtotal) }}</td>
          </tr>
          <tr>
            <td colspan="7"></td>
            <td align="right"><b>{{ toMoney(
                fees.payment.ticket.credit.subtotal +
                fees.payment.ticket.debit.subtotal +
                fees.payment.ticket.pix.subtotal +
                fees.payment.ticket.cash.subtotal +
                fees.payment.online.credit.subtotal +
                fees.payment.online.pix.subtotal +
                fees.payment.online.billet.subtotal +
                fees.print.subtotal +
                fees.issue.subtotal
              )
            }}</b></td>
          </tr>
        </table>

        <table class="table-bordero">
          <br>
          <br>
          <tr>
            <th colspan="7">RESUMO</th>
          </tr>
          <tr>
            <th></th>
            <th colspan="2">Canal</th>
            <th>Qtd</th>
            <th>Subtotal</th>
            <th>Percentual</th>
            <th>Totais</th>
          </tr>
          <tr>
            <td rowspan="2">ENTRADAS</td>
            <td colspan="2"><b>Bilheteria</b></td>
            <td align="right">{{ summary.in.ticket.amount }}</td>
            <td align="right">{{ toMoney(summary.in.ticket.total) }}</td>
            <td align="right">{{ summary.in.ticket.percent ? summary.in.ticket.percent.toFixed(0) : 0 }} %</td>
            <td rowspan="2" align="right">{{ toMoney(summary.in.total) }}</td>
          </tr>
          <tr>
            <td colspan="2"><b>Online</b></td>
            <td align="right">{{ summary.in.online.amount }}</td>
            <td align="right">{{ toMoney(summary.in.online.total) }}</td>
            <td align="right">{{ summary.in.online.percent ? summary.in.online.percent.toFixed(0) : 0 }} %</td>
          </tr>
          <tr>
            <td rowspan="4">SAÍDAS</td>
            <td rowspan="2"><b>Bilheteria</b></td>
            <td>Taxa pagamento</td>
            <td align="right">{{ summary.out.ticket.payment.amount }}</td>
            <td align="right">{{ toMoney(summary.out.ticket.payment.total) }}</td>
            <td align="right">{{ summary.out.ticket.payment.percent ? summary.out.ticket.payment.percent.toFixed(0) : 0
            }} %
            </td>
            <td rowspan="4" align="right">{{ toMoney(summary.out.total) }}</td>
          </tr>
          <tr>
            <td>Impressão</td>
            <td align="right">{{ summary.out.ticket.print.amount }}</td>
            <td align="right">{{ toMoney(summary.out.ticket.print.total) }}</td>
            <td align="right">{{ summary.out.ticket.print.percent ? summary.out.ticket.print.percent.toFixed(0) : 0 }} %
            </td>
          </tr>
          <tr>
            <td rowspan="2"><b>Online</b></td>
            <td>Taxa pagamento</td>
            <td align="right">{{ summary.out.online.payment.amount }}</td>
            <td align="right">{{ toMoney(summary.out.online.payment.total) }}</td>
            <td align="right">{{ summary.out.online.payment.percent ? summary.out.online.payment.percent.toFixed(0) : 0
            }} %
            </td>
          </tr>
          <tr>
            <td>Emissão</td>
            <td align="right">{{ summary.out.online.issue.amount }}</td>
            <td align="right">{{ toMoney(summary.out.online.issue.total) }}</td>
            <td align="right">{{ summary.out.online.issue.percent ? summary.out.online.issue.percent.toFixed(0) : 0 }} %
            </td>
          </tr>
          <tr>
            <td colspan="6"></td>
            <td align="right"><b>{{ toMoney(summary.net) }}</b></td>
          </tr>
        </table>

        <table class="table-bordero">
          <br>
          <br>
          <tr>
            <th colspan="3">REPASSES</th>
          </tr>
          <tr>
            <td>Resultado a pagar à produção</td>
            <td align="right">{{ transfers.producer.percent ? transfers.producer.percent.toFixed(0) : 0 }} %</td>
            <td align="right">{{ toMoney(transfers.producer.total) }}</td>
          </tr>
          <tr>
            <td>Resultado destinado ao estabelecimento</td>
            <td align="right">{{ transfers.business.percent ? transfers.business.percent.toFixed(0) : 0 }} %</td>
            <td align="right">{{ toMoney(transfers.business.total) }}</td>
          </tr>
        </table>

        <div class="print-signture">
          <div class="print-signture-text">ESTABELECIMENTO</div>
          <div class="print-signture-text">PRODUÇÃO</div>
          <div class="print-signture-date">{{ (new Date()).toLocaleString('pt-br') }}</div>
        </div>

        <table v-if="full & tickets.length > 0" class="table-bordero" style="page-break-inside: avoid;">
          <!--style="page-break-inside: initial"-->
          <br>
          <br>
          <tr>
            <th colspan="8">INGRESSOS</th>
          </tr>
          <tr>
            <th>Assento</th>
            <th>Canal</th>
            <th>Titular</th>
            <th>Tipo de Ingresso</th>
            <th>Forma de pagamento</th>
            <th>Data da venda</th>
            <th>Data do recebimento</th>
            <th>Valor</th>
          </tr>
          <tr v-for="ticket in tickets" :key="ticket.id">
            <td style="max-width:100px;" v-if="show && !show.showDate[0].withoutStage && !show.show.online"
              align="left">{{ ticket.seat }}</td>
            <td align="left">{{ ticket.tiketera ? 'Online' : 'Bilheteria' }}</td>
            <td align="left">{{ ticket.name || ticket.ticketName || '-' }} <span v-if="ticket.email"
                style="display: block; font-size: 0.8em">{{ ticket.email }}</span> <span
                v-if="ticket.phone || ticket.ticketPhone" style="display: block; font-size: 0.8em">{{ ticket.phone ||
                    ticket.ticketPhone
                }}</span></td>
            <td align="left">{{ ticket.ticketType }}</td>
            <td style="min-width:100px;" align="left">{{ ticket.paymentMethod === 'card' ? 'Cartão' :
              ticket.paymentMethod === 'billet' ? 'Boleto' :
              ticket.paymentMethod === 'pix' ? 'PIX' :
              ticket.paymentMethod === 'external' ? 'Externo' :
              ticket.paymentMethod === 'debit' ? 'Débito' :
              ticket.paymentMethod === 'cortesy' ? 'Cortesia' :
              ticket.paymentMethod === 'cash' ? 'Dinheiro' : ticket.paymentMethod}}</td>
            <td style="min-width:100px;" align="left">{{ ticket.dateSale }}</td>
            <td style="min-width:100px;" align="left">{{ ticket.dateReceive }}</td>
            <td style="min-width:100px;" align="right">R$ {{ ticket.price.toLocaleString('pt-br', {
                minimumFractionDigits: 2
              })
            }}</td>
          </tr>
        </table>
      </div>
    </transition>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import logger from '../../logger'
import { getForBusiness, getForProducer } from '../api/bordero'

export default {
  name: 'bordero',
  props: ['id'],
  data () {
    return {
      full: false,
      show: null,
      ticketsBusiness: [],
      ticketsTiketera: [],
      business: null,
      revenue: 0,
      notSold: 0,
      free: 0,
      paid: 0,
      total: 0,
      occupation: 0,
      capacity: 0,
      expenses: [],
      expense: 0,
      tickets: [],
      fees: {},
      summary: {},
      transfers: {},
      producer: {}
    }
  },
  computed: {
    ...mapState(['user'])
  },
  async mounted () {
    try {
      let data = {}
      // Producer
      if (this.user.role === 'producer') {
        data = await getForProducer(this.id)
        // Business
      } else {
        data = await getForBusiness(this.id)
      }
      this.ticketsBusiness = data.ticketsBusiness
      this.ticketsTiketera = data.ticketsTiketera
      this.business = data.business
      this.expenses = data.expenses
      // Show
      this.show = data
      this.revenue = data.revenue
      this.notSold = data.notSold
      this.free = data.free
      this.paid = data.paid
      this.total = data.total
      this.occupation = data.occupation
      this.capacity = this.total + this.notSold
      this.expense = data.expense
      this.tickets = data.tickets ? data.tickets : []
      this.fees = data.fees
      this.summary = data.summary
      this.transfers = data.transfers
      this.producer = data.producer
    } catch (error) {
      logger.warn(error)
    }
  },
  methods: {
    print () {
      window.print()
    },
    toMoney (value) {
      return `R$ ${value.toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";

$color-revenue: $primary-color;
$color-expense: rgb(130, 0, 0);

.calendar {
  width: 40px;
  height: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
  border-radius: 5px;
  margin-right: 10px;
  font-weight: 500;

  span:nth-child(1) {
    font-size: 1.2em;
  }

  span:nth-child(2) {
    font-size: 0.7em;
  }
}

.time-text {
  font-size: 2.2em;
  font-weight: 400;
  margin-right: 10px;
  color: #555;
  display: flex;

  span:nth-child(2) {
    font-size: 0.5em;
    line-height: 2em;
  }
}

.actions {
  display: flex;
  justify-content: space-between;
  padding-bottom: 25px;
}

.button-previous {
  display: flex;
  align-items: center;
  color: $primary-color;
  border: 1px solid $primary-color;
  border-radius: 100px;
  box-shadow: 0 0 3px $primary-color;
  background-color: #fff;
  font-size: 1em;
  width: 40px;
  height: 40px;
  cursor: pointer;

  &:focus {
    outline: 0;
  }

  span {
    overflow: hidden;
    max-width: 0;
    opacity: 0;
    font-weight: bold;
    transition: max-width 0.3s, opacity 0.2s;
  }

  i {
    flex: 1;
  }
}

.button-save {
  color: #fff;
  border: none;
  border-radius: 100px;
  box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.4);
  background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
  font-size: 1em;
  font-weight: 400;
  width: auto;
  height: 40px;
  padding: 0 15px;
  cursor: pointer;

  &:focus {
    outline: 0;
  }

  i {
    margin-right: 0;
  }

  span {
    display: none;
  }
}

.button-previous:hover {
  width: auto;
  padding: 0 15px;
  background-color: $hover-color;

  i {
    margin-right: 7px;
    animation-name: ticket-previous;
    animation-timing-function: ease-in-out;
    animation-duration: 0.5s;
    animation-iteration-count: 5;
  }

  span {
    max-width: 100px;
    opacity: 1;
  }
}

.button-save:hover {
  i {
    animation-name: ticket-save;
    animation-timing-function: ease-in-out;
    animation-duration: 0.8s;
    animation-iteration-count: 5;
  }
}

.table {
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    padding: 8px 10px;
    font-weight: 400;
  }

  tr {
    font-size: 1em;
    color: #555;

    &:nth-child(2n+1) {
      background-color: #e5e5e5;
    }

    &.footer>td {
      // color: #fff;
      // background-color: #555;
      color: #555;
      font-weight: 500;
      background-color: #fff;
      border-top: 2px solid #555;
    }
  }

  .head {
    color: $color-revenue;
    border-bottom: 2px solid $color-revenue;
    background-color: #fff !important;

    th {
      font-weight: 500;
      margin-top: 10px;
    }

    &.expense {
      color: $color-expense;
      border-bottom: 2px solid $color-expense;
    }
  }
}

.table-tickets {
  page-break-before: always;
  margin-top: 30px;

  .head {
    color: #555;
    border-bottom: 2px solid #555;
  }
}

.information {
  margin: 30px 5px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;

  .info-reveneu {
    color: $color-revenue !important;
  }

  .info-expense {
    color: $color-expense !important;
  }

  .info-box {
    margin: 10px 5px;
    width: calc(50% - 20px);
  }

  .info-text {
    font-size: 1em;
    font-weight: 400;
    color: #777;
    text-transform: uppercase;
  }

  .info-value {
    font-size: 2em;
    font-weight: 400;
    color: $primary-color;

    span {
      font-size: 0.5em;
      font-weight: 300;
      color: #999;
    }
  }

  .info-bigger {
    width: 100%;

    .info-text {
      font-size: 1.6em;
    }

    .info-value {
      font-size: 3em;
      color: $secondary-color;
    }
  }
}

.print-header {
  display: none;
  justify-content: space-between;
  align-items: center;
  border-bottom: 5px solid $primary-color;
  padding: 20px 15px;
}

.print-title {
  font-size: 2em;
  color: $primary-color;
  font-weight: 500;
}

.print-business {
  display: none;
  justify-content: space-between;
  align-items: flex-start;
  padding: 30px 10px;
}

.print-text {
  font-size: 0.9em;
  color: #555;
}

.print-signture {
  display: none;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-items: center;
  padding-top: 50px;
}

.print-signture-text {
  width: 200px;
  border-top: 1px solid #555;
  text-align: center;
  font-size: 0.8em;
  padding-top: 2px;
}

.print-signture-date {
  width: 100%;
  font-size: 0.9em;
  color: #555;
  padding-top: 20px;
  text-align: center;
}

.list {
  .actions {
    display: none;
  }
}

.show-print {
  display: none !important;
}

.print-type {
  display: flex;
  align-items: center;

  div {
    color: $secondary-color;
    flex-shrink: 0;
    padding: 8px 15px;
    border: 2px solid $secondary-color;
    cursor: pointer;
  }

  div:nth-child(1) {
    border-radius: 50px 0 0 50px;
  }

  div:nth-child(2) {
    border-radius: 0 50px 50px 0;
  }

  .print-type-selected {
    color: #fff;
    background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
  }
}

.table-bordero {
  width: 100%;
  color: #555;
  border-collapse: collapse;
  margin: 20px 0;

  th {
    background-color: #e5e5e5;
    font-size: 1.1rem;
    padding: 5px 0;
    border: 1px solid #ddd;
    margin-top: 10px;
  }

  tr:nth-child(2) {
    th {
      font-size: 1rem;
      text-align: left;
      padding: 5px;
    }
  }

  td {
    border: 1px solid #ddd;
    padding: 5px;
  }
}

// Desktop
@media screen and (min-width: $desktop-width) {
  .information {
    flex-wrap: nowrap;

    .info-box {
      width: auto;
    }
  }

  .button-save {
    i {
      margin-right: 7px;
    }

    span {
      display: inline-block;
    }
  }
}
</style>

<style lang="scss">
// Print
@media print {

  /*
  * {
    margin: 0;
    padding: 0;
  }

  @page {
    size: auto;
    margin: 0;
    padding: 0;
  }*/
  @page {
    size: A4;
    margin-top: 50px;
    margin-bottom: 50px;
  }

  header,
  footer {
    display: none;
  }

  body {
    overflow: visible !important;
    -webkit-print-color-adjust: exact !important;
    font: 8pt sans-serif;
    line-height: 1.3;
  }

  .menu {
    display: none !important;
  }

  .admin-router {
    margin: 0 !important;
  }

  .listing {
    margin: 0 10mm 10mm !important;
  }

  .actions {
    display: none !important;
  }

  .print-header {
    display: flex !important;
    margin: -3mm -13mm 0 !important;
    padding: 6mm 15mm !important;
  }

  .print-business {
    display: flex !important;
  }

  .print-signture {
    display: flex !important;
  }

  .information {
    .info-box {
      width: auto !important;
    }
  }

  .list {
    .actions {
      display: block !important;
    }
  }

  .show-print {
    display: block !important;
  }

  .table-bordero {
    margin: 10mm 0 !important;
    page-break-inside: avoid;
  }

  th {
    font-size: 12px !important;
  }

  td {
    font-size: 10px !important;
  }

  tr {
    page-break-inside: avoid;
    page-break-after: auto;
    font-size: 10px !important;
  }
}
</style>
